export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "handler_notice_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sinistre géré par un prestataire externe"])},
        "handler_notice_quotation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le sinistre est pris en charge par un prestataire externe : le devis est demandé directement au client. Aucune action n'est attendue de votre part."])},
        "handler_notice_invoice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le sinistre est pris en charge par un prestataire externe : la facture est demandée directement au client. Aucune action n'est attendue de votre part."])}
      },
      "en": {
        "handler_notice_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Claim handled by an external provider"])},
        "handler_notice_quotation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The claim is handled by an external provider: the quotation is requested directly from the customer. No action is expected on your side."])},
        "handler_notice_invoice": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The claim is handled by an external provider: the invoice is requested directly from the customer. No action is expected on your side."])}
      }
    }
  })
}
